import React from "react";
import styles from "./FlightInfo.module.scss";
import {IProduct} from 'data/interfaces/products';
import AdExitTime
  from 'gui/components/listPage/components/ad/components/adExitTime';
import AdReturnTime
  from 'gui/components/listPage/components/ad/components/adReturnTime';
import AdAirlineCompany
  from 'gui/components/listPage/components/ad/components/adAirlineCompany';
import AdTickets from 'gui/components/listPage/components/ad/components/adTickets';
import FlightInfoSquare
  from 'gui/components/listPage/components/ad/components/flightInfoSquare';
import AdInfo from 'gui/pages/mainRouter/pages/ad/components/commons/adInfo';


export interface IFlightInfoProps {
  product: IProduct;
  className?: string;
  title?: string;
  hideTitle?: boolean;
  additionalDetails?: any;
}

const FlightInfo = (props: IFlightInfoProps) => (
  <AdInfo {...props} className={styles.flightInfo}>
    <div className={styles.content}>
      <div>
        <AdExitTime ticketDetails={props.product.ticketDetails}/>
        <AdReturnTime ticketDetails={props.product.ticketDetails}/>
        <AdAirlineCompany ticketDetails={props.product.ticketDetails}/>
        <AdTickets ticketDetails={props.product.ticketDetails}/>
      </div>
      <FlightInfoSquare
        style={{backgroundColor: "transperent", height: "initial"}}
        showIcon={false}
        product={props.product}/>
    </div>

  </AdInfo>
);

FlightInfo.defaultProps = {
  product: {},
  title: 'מידע:',
  className: '',
  additionalDetails: null,
};

export default FlightInfo;
